import {Box, Button, Stack} from "@mui/material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import {GenerationTypeEnum} from "../shared/types/GenerationTypeEnum.ts";
import {MediaSkeleton} from "../shared/ui/MediaSkeleton.tsx";
import {useState} from "react";

type PhotoPreviewType = 'initial' | 'effect';

interface IPhotoPreviewCardProps {
    imageSrc: string;
    type: PhotoPreviewType;
    mediaType: GenerationTypeEnum;
    onChangeClick: () => void;
}

export const PhotoPreviewCard = ({imageSrc, type, onChangeClick}: IPhotoPreviewCardProps) => {
    const buttonLabel = type === 'initial' ? 'Change Photo' : 'Change Effect';
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <Stack
            direction="column"
            alignItems="center"
            spacing={1}
            sx={{
                alignSelf: 'flex-end',
                borderRadius: '12px',
                minWidth: '150px',
            }}
        >
            {!isLoaded && (
                <MediaSkeleton
                    width="100%"
                    height="220px"
                    borderRadius="14px"
                />
            )}
            <Box
                component="img"
                src={imageSrc}
                alt={type === 'initial' ? 'Your photo' : 'Effect preview'}
                onLoad={() => setIsLoaded(true)}
                sx={{
                    maxWidth: '100%',
                    height: '220px',
                    borderRadius: '14px',
                    objectFit: 'cover',
                    objectPosition: 'top',
                    display: isLoaded ? 'block' : 'none'
                }}
            />
            <Button
                onClick={onChangeClick}
                variant="text"
                size="small"
                startIcon={<SwapHorizIcon />}
                sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '12px',
                    width: '100%',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    border: 'none',
                    backdropFilter: 'none',
                    WebkitBackdropFilter: 'none',
                }}
            >
                {buttonLabel}
            </Button>
        </Stack>
    );
};
